/* eslint-disable */
import React, { useState } from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import Container from "../layout/container"
import cardsContent from "../../content/agence-amazon/cards.json"
import Card from "./card"

const Cards = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query CardSectionQuery {
      card1: file(relativePath: { eq: "illustration-conseil-strategie.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      card2: file(relativePath: { eq: "illustration-brand-content.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      card3: file(relativePath: { eq: "illustration-campagnes-retail.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      card4: file(relativePath: { eq: "illustration-support-ope.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      card5: file(relativePath: { eq: "illustration-formations.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  const { card1, card2, card3, card4, card5 } = cardsContent[langKey]

  const [activeCardId, _setActiveCardId] = useState(0)
  const [isActive, _setisActive] = useState(true)

  const setActiveCardId = cardId => {
    if ((cardId => 0) && cardId <= 4) {
      _setActiveCardId(cardId)
      _setisActive(true)
    } else {
      throw Error("You should select a card that exsits")
    }
  }

  return (
    <Container id="kickstart">
      <div
        sx={{
          width: ["100%", "100%", "70%"],
          display: `flex`,
          flexDirection: `row`,
          alignItems: `center`,
          justifyContent: `space-evenly`,
          overflowX: `auto`,
          marginTop: `4rem`,
          mx: "auto",
        }}
      >
        <Link
          to={
            langKey === "fr"
              ? `/${langKey}/services/eretail-consulting`
              : `/services/eretail-consulting`
          }
          sx={{ textDecoration: "none" }}
        >
          <Card
            fixed={data.card1.childImageSharp.fixed}
            title={"eRetail Consulting"}
            cardId={1}
            activeCardId={activeCardId}
          />
        </Link>
        <Link
          to={
            langKey === "fr"
              ? `/${langKey}/services/eretail-media`
              : `/services/eretail-media`
          }
          sx={{ textDecoration: "none" }}
        >
          <Card
            fixed={data.card2.childImageSharp.fixed}
            title={"eRetail Media"}
            cardId={2}
            activeCardId={activeCardId}
          />
        </Link>
        <Link
          to={
            langKey === "fr"
              ? `/${langKey}/services/eretail-content`
              : `/services/eretail-content`
          }
          sx={{ textDecoration: "none" }}
        >
          <Card
            fixed={data.card3.childImageSharp.fixed}
            title={"eRetail Content"}
            cardId={3}
            activeCardId={activeCardId}
          />
        </Link>
      </div>
    </Container>
  )
}

export default Cards
